(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

module.exports = circumradius;

var circumcenter = require('circumcenter');

function circumradius(points) {
  var center = circumcenter(points);
  var avgDist = 0.0;

  for (var i = 0; i < points.length; ++i) {
    var p = points[i];

    for (var j = 0; j < center.length; ++j) {
      avgDist += Math.pow(p[j] - center[j], 2);
    }
  }

  return Math.sqrt(avgDist / points.length);
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(circumradius, "circumradius", "/home/yatham/Dev_BHS_Portal/node_modules/circumradius/crad.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();